import { mapState } from 'vuex';
import courseslist from "./list/index.vue";

export default {
    name: 'courses',
    props: {
    },

    data : function(){

        return {
            loading : true,
            tokens : []
        }

    },

    components : {
        courseslist
    },

    created()  {
        this.load()
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,

        cancreate : function(){
            return this.core.appInfo && (!this.core.appInfo.courseByToken || this.tokens.length) && this.core.user.checkFeatures(['lessons'])
        },

        token : function(){
            if (this.tokens.length){
                return this.tokens[0].token
            }
        }
    }),

    methods : {
        load : function(){

            if(!this.core.appInfo.courseByToken) {
                this.loading = false
                return
            }

            this.loading = true

            this.core.api.lessons.getTokens().then(tokens => {
                this.tokens = tokens
            }).finally(() => {
                this.loading = false
            })
        },

        create : function(){
            this.core.vueapi.coursecreate()
        }
    },
}